import React, { useEffect, useState } from "react";
import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import CreatePage from "./CreatePage";
import ManagePage from "./ManagePage";
import { auth } from "../../utils/firebase.config";
import "./style.css";

const AdminPanel = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authUser, setAuthUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authBusy, setAuthBusy] = useState(false);
  const [authError, setAuthError] = useState("");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthUser(user);
      setAuthLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    setAuthBusy(true);
    setAuthError("");

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      setPassword("");
    } catch (loginError) {
      console.error("admin login error", loginError);
      setAuthError("Credenciales inválidas o usuario sin permisos.");
    } finally {
      setAuthBusy(false);
    }
  };

  const handleLogout = async () => {
    setAuthBusy(true);
    setAuthError("");
    try {
      await signOut(auth);
    } catch (logoutError) {
      console.error("admin logout error", logoutError);
      setAuthError("No se pudo cerrar sesión. Inténtalo de nuevo.");
    } finally {
      setAuthBusy(false);
    }
  };

  if (authLoading) {
    return (
      <section id="admin-panel" className="admin-panel">
        <div className="container" data-aos="fade-up">
          <div className="admin-auth-card">
            <h2 className="section-subtitle">Panel de Invitaciones</h2>
            <p className="status">Verificando acceso...</p>
          </div>
        </div>
      </section>
    );
  }

  if (!authUser) {
    return (
      <section id="admin-panel" className="admin-panel">
        <div className="container" data-aos="fade-up">
          <div className="admin-auth-card">
            <h2 className="section-subtitle">Panel de Invitaciones</h2>
            <h3>Acceso restringido</h3>
            <p>Inicia sesión con una cuenta de administrador.</p>

            <form className="admin-auth-form" onSubmit={handleLogin}>
              <div className="field-block">
                <label htmlFor="admin-email">Correo</label>
                <input
                  id="admin-email"
                  type="email"
                  value={email}
                  autoComplete="username"
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="admin@correo.com"
                  required
                />
              </div>
              <div className="field-block">
                <label htmlFor="admin-password">Contraseña</label>
                <input
                  id="admin-password"
                  type="password"
                  value={password}
                  autoComplete="current-password"
                  onChange={(event) => setPassword(event.target.value)}
                  placeholder="********"
                  required
                />
              </div>
              <button type="submit" className="btn-primary" disabled={authBusy}>
                {authBusy ? "Entrando..." : "Entrar al panel"}
              </button>
            </form>
            {authError && <p className="status error">{authError}</p>}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="admin-panel" className="admin-panel">
      <div className="container" data-aos="fade-up">
        <div className="admin-header text-center">
          <h2 className="section-subtitle">Panel de Invitaciones</h2>
          <h3>Administración de familias, invitados y QR</h3>
          <p className="admin-auth-user">Sesión: {authUser.email}</p>
          <button
            type="button"
            className="btn-secondary"
            onClick={handleLogout}
            disabled={authBusy}
          >
            {authBusy ? "Cerrando..." : "Cerrar sesión"}
          </button>
        </div>

        <div className="panel-nav">
          <NavLink
            to="/panel/crear"
            className={({ isActive }) =>
              isActive ? "panel-nav-link active" : "panel-nav-link"
            }
          >
            Crear invitación
          </NavLink>
          <NavLink
            to="/panel/gestionar"
            className={({ isActive }) =>
              isActive ? "panel-nav-link active" : "panel-nav-link"
            }
          >
            Gestionar base de datos
          </NavLink>
        </div>

        <Routes>
          <Route path="/" element={<Navigate to="/panel/crear" replace />} />
          <Route path="/crear" element={<CreatePage />} />
          <Route path="/gestionar" element={<ManagePage />} />
        </Routes>
      </div>
    </section>
  );
};

export default AdminPanel;
